module.exports = __webpack_public_path__ + "img/venator.dacda240.jpg";